import type { MeasurementStore } from '../../services/MeasurementStore';
import type { DomEventService } from '../../services/browser';
import { createShopware66PdpMeasurementStrategies, PdpMeasurementStrategyComposite } from './measurements';

let detachMeasurementListeners: (() => void) | null = null;

/** Idempotent: safe when nothing is attached (e.g. first cold start or SSR). */
export function detachShopware66MeasurementListeners(): void {
  detachMeasurementListeners?.();
  detachMeasurementListeners = null;
}

/**
 * Shopware 6.6 PDP measurement entry: wires the default strategy composite and replaces any prior attach
 * so consent cold-starts / re-inits do not stack duplicate global listeners.
 *
 * Plugin coverage: see `measurements/*` — each strategy documents which Store extensions / DOM patterns
 * it is aimed at; this file only composes them.
 */
export function attachShopware66MeasurementListeners(
  events: DomEventService,
  store: MeasurementStore,
): void {
  detachShopware66MeasurementListeners();

  const doc = typeof document !== 'undefined' ? document : undefined;
  const win = typeof window !== 'undefined' ? window : undefined;
  if (!doc || !win) {
    return;
  }

  const composite = new PdpMeasurementStrategyComposite(createShopware66PdpMeasurementStrategies());
  composite.attach({ events, store, document: doc, window: win });
  detachMeasurementListeners = () => {
    composite.dispose();
  };
}
